/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Encapsulates a lookup code used within the RdSAP system for standardized data referencing and retrieval.
 */
export interface RdSAPLookupCodeDtoV0 { 
    /**
     * Drop List - Grouping Value. The specific data item to which the lookup code pertains. Items are grouped by this value.
     */
    dataItem: string;
    /**
     * The UI text that appears in the drop list. The particular item within the data set that the lookup code references. (TBC - Is this a SAP ENUM value?)
     */
    lookUpItem: string;
    /**
     * An override for lookUpItem. The UI text that appears in the drop list. A custom name for the lookup item, if applicable.
     */
    customLookName?: string | null;
    /**
     * The ID value associated with the lookup item. This appears to be the SAP Enum ordinal.
     */
    lookupValue: string;
    /**
     * The version of the RdSAP methodology used for the lookup code.
     */
    rdsapVersion: string;
}

